// Copyright (c) 2019 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import Warranty from '@deere/cps-it.warranty-model-factory/lib/warranty';
import WarrantyCoverageItem from '../../../product/details/components/warranty-coverage-panel/warranty-coverage-item';

const WarrantyStatusModalBody = props => {

    const warrantyCoverageItems = props.warranties.map(warrantyCoverageItem =>
        <WarrantyCoverageItem
            key={warrantyCoverageItem.id + warrantyCoverageItem.warrantyItemText.replace(/ /g, '_')}
            showDisabledClass={false}
            warranty={warrantyCoverageItem}
        />
    );

    return (
        <div className='modal-body'>
            <section className='warranty-coverage-panel'>
                {props.warranties.length ?
                    <div>{warrantyCoverageItems}</div> :
                    <FormattedMessage id='NO_RESULTS_FOUND'/>
                }
            </section>
        </div>
    );

};

WarrantyStatusModalBody.displayName = 'WarrantyStatusModalBody';
WarrantyStatusModalBody.propTypes = {
    showDisabledClass: PropTypes.bool.isRequired,
    warranties: PropTypes.arrayOf(PropTypes.instanceOf(Warranty)).isRequired
};

export default WarrantyStatusModalBody;



// WEBPACK FOOTER //
// ./src/shared/components/warranty-status-modal/warranty-status-modal-body.js